// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__3bwEJ","author":"Table_author__34HY6","authorImage":"Table_authorImage__2Gk87","unreadRow":"Table_unreadRow__2tRY9"};